import React, { useEffect, useState } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { Container, Row, Col } from 'react-grid-system'
import classNames from 'classnames';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router';

import {
  UniConditionalRender,
  UniLocalize,
  UniWorkflow,
  UniImg,
  getClientOperatingSystem,
  EUserAgentOS,
  UniSelect,
  IAppleWalletPassStatusResponseC,
  UniButton,
  noop
} from '@unikey/unikey-commons/release/comm';

import {
  useAppSelector,
  useAppDispatch,
  PartnerCustomizations,
  IPartnerCustomizations,
  partnerKey,
  iosAppStoreLink,
  googlePlayStoreLink,
  attemptSilentCheckAppleWalletInvitationPassStatus,
  AddToAppleWalletContainer,
  storeHistory,
  api,
  redirectToLogin,
  addPendingRedirect,
  ENavPages,
  navConfig,
} from '../internal'

import partnerConfig from '@alias-current-partner-customizations';

interface IProps extends WrappedComponentProps, IPartnerCustomizations {

}

const WalletAccept = (props: IProps) => {

  const routeParams = useParams();
  const dispatch = useAppDispatch();
  const auth = useAuth();
  
  const $walletStatus: IAppleWalletPassStatusResponseC = useAppSelector(state => state.appleWalletStatus.walletStatus);
  const $walletStatusLoading: boolean = useAppSelector(state => state.appleWalletStatus.loading);

  useEffect(() => {
    const inviteTokenFromParams = routeParams.inviteToken ?? '';
    // when the selected site changes, we want to call to see 
    // if apple wallet is allowed in the new selected site
    if (inviteTokenFromParams) {
      dispatch(attemptSilentCheckAppleWalletInvitationPassStatus({ inviteToken: inviteTokenFromParams }));
    }
  }, [routeParams.inviteToken]);

  const iOSAppLinkConfigured = /http/.test(iosAppStoreLink);
  const googleAppLinkConfigured = /http/.test(googlePlayStoreLink);

  const mobileOS = getClientOperatingSystem();
  const imgClassName = classNames('partner-logo', {
    [partnerKey]: true
  });

  return (
    <section className="access-container">

      <section className="accept-wallet-container">
        {/* access flow should conform to max width restrictions for massive screens */}
        <Container>
          <UniImg className={imgClassName} textKey="partner logo" src={props.darkModeActive ? partnerConfig.assets.logoOnDark : partnerConfig.assets.logoOnBackground} />
          <UniWorkflow
            titleKey="addToWallet"
            titleIcon="wallet"
            size="wider">

            <UniConditionalRender visible={$walletStatus.is_apple_wallet_enabled_for_org || !$walletStatusLoading}>
              <p className="text-center"><UniLocalize translate="addAnAccessPassToWallet" /></p>

              <Row>
                {/* <Col xs={20} sm={mobileOS === EUserAgentOS.unknown ? 12 : 18 } offset={{ xs: mobileOS === EUserAgentOS.unknown ? 1 : 3, sm: mobileOS === EUserAgentOS.unknown ? 0 : 3 }}> */}
                <Col xs={20} sm={18} offset={{ xs: 2, sm: 3 }}>
                  <AddToAppleWalletContainer
                    key={routeParams.inviteToken}
                    inviteToken={routeParams.inviteToken}
                    appleWalletAllowedOverride={true} />
                </Col>
              </Row>

              {/* <UniConditionalRender visible={googleAppLinkConfigured || iOSAppLinkConfigured}>
                <p className="or-divider-full-width eq-top-bottom">
                  <span className="or-text"><UniLocalize translate="_orDivider" /></span>
                </p>
              </UniConditionalRender> */}
            </UniConditionalRender>

            {/* TODO: restore applinks when the JWT invite token includes value for bluetooth_enabled true/false  */}
            {/* <UniConditionalRender visible={googleAppLinkConfigured || iOSAppLinkConfigured}>
              <p className="text-center"><UniLocalize translate="downloadTheMobileApp" /></p>
              <Row>
                <UniConditionalRender visible={/http/.test(iosAppStoreLink) && (mobileOS === EUserAgentOS.iOS || mobileOS === EUserAgentOS.unknown)}>
                  <Col xs={20} sm={mobileOS === EUserAgentOS.unknown ? 12 : 18 } offset={{ xs: mobileOS === EUserAgentOS.unknown ? 2 : 3, sm: mobileOS === EUserAgentOS.unknown ? 0 : 3 }}>
                    <a className="app-badge-link" href={iosAppStoreLink}>
                      <UniImg textKey="downloadAppInAppStore" className="app-badge-image iOS" src="https://unikeystatic.blob.core.windows.net/assets/commercial-app/shared/app-store-badge.png" />
                    </a>
                  </Col>
                </UniConditionalRender>

                <UniConditionalRender visible={/http/.test(googlePlayStoreLink) && (mobileOS === EUserAgentOS.Android || mobileOS === EUserAgentOS.unknown)}>
                  <Col xs={20} sm={mobileOS === EUserAgentOS.unknown ? 12 : 18 } offset={{ xs: mobileOS === EUserAgentOS.unknown ? 2 : 3, sm: mobileOS === EUserAgentOS.unknown ? 0 : 3 }}>
                    <a className="app-badge-link" href={googlePlayStoreLink}>
                      <UniImg textKey="downloadAppInGooglePlayStore" className="app-badge-image android" src="https://unikeystatic.blob.core.windows.net/assets/commercial-app/shared/google-play-badge.png" />
                    </a>
                  </Col>
                </UniConditionalRender>

              </Row>
            </UniConditionalRender> */}

          </UniWorkflow>


        </Container>
      </section>
    </ section>
  );
}

export default PartnerCustomizations(
  injectIntl(WalletAccept), 
  { componentName: 'WalletAccept' }
)